import React from 'react';
import MREC from '../../shared/mrec';
import SidebarContext from './sidebar-context';

export default function MRECSidebar() {
  const { ads } = React.useContext(SidebarContext);
  return <MREC ads={ads} classNames="mrec" />;
}
